export default {
  mounted() {
    this.handleEvent('server_form_submit', ({ target }) => {
      if (target !== this.el.id) return

      // Trigger a submit of the form this is a hook for, handy when the submit button can't be in the
      // form's HTML scope. For example the New Planning Area form where there is the TextEdit's form,
      // then an Upload form, then the submit button for the TextEdit's.
      // https://hexdocs.pm/phoenix_live_view/js-interop.html#triggering-phx-form-events-with-javascript
      this.el.dispatchEvent(
        new Event('submit', { bubbles: true, cancelable: true })
      )
    })
  }
}
